import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader, Sort } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { StoreDto } from '@dto';

@Component({
  imports: [
    TranslatePipe,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatPaginator,
    MatSortHeader,
    DecimalPipe,
  ],

  selector: 'monitor-ui-table',
  styleUrls: ['./der-table.component.scss'],
  templateUrl: './der-table.component.html',
})
export class DerTableComponent implements OnChanges {
  dataSource: MatTableDataSource<StoreDto>;
  displayedColumns = ['type', 'available', 'name', 'status', 'soc', 'usableEnergy', 'nameplateEnergy', 'currentPower'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() stores: StoreDto[];

  ngOnChanges(): void {
    if (this.stores) {
      this.initDataSource(this.stores);
    }
  }

  sortData(sort: Sort): void {
    let data = this.stores.slice();
    if (!sort.active || sort.direction === '') {
      this.initDataSource(this.stores);
      return;
    }

    data = data.sort((configuration1: StoreDto, configuration2: StoreDto) => {
      const isAscending = sort.direction === 'asc';
      switch (sort.active) {
        case 'derType':
          return this.compare(configuration1.derType ?? '', configuration2.derType, isAscending);
        case 'name':
          return this.compare(configuration1.displayLabel, configuration2.displayLabel, isAscending);
        case 'status':
          return this.compare(configuration1.status, configuration2.status, isAscending);
        case 'soc':
          return this.compare(configuration1.soc, configuration2.soc, isAscending);
        case 'usableEnergy':
          return this.compare(configuration1.usableEnergy, configuration2.usableEnergy, isAscending);
        case 'nameplateEnergy':
          return this.compare(configuration1.nameplateEnergy, configuration2.nameplateEnergy, isAscending);
        case 'currentPower':
          return this.compare(configuration1.power, configuration2.power, isAscending);
        default:
          return 0;
      }
    });

    this.initDataSource(data);
  }

  private compare(a: number | string, b: number | string, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private initDataSource(stores: StoreDto[]): void {
    if (!stores?.length) {
      return;
    }
    const initTable = (): void => {
      this.dataSource = new MatTableDataSource<StoreDto>(stores);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    };
    setTimeout(initTable);
  }
}
